import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Breadcrumb from "../Breadcrumb";
import ContactInfo from "./ContactInfo";
import AdditionalInfo from "./AdditionalInfo";
import "./PersonHero.scss";

const PersonHero: React.FC<JQI.PersonHeroProps> = ({
  name,
  personTitle,
  roles,
  image,
  contactInfo,
  cv,
  researchProfile,
  breadcrumb,
}) => {
  const imageData = !!image.data ? getImage(image.data) : null;

  return (
    <div className="person-hero">
      <Breadcrumb {...breadcrumb} />
      <div className="person-hero__inner">
        <h1 className="person-hero__name">{name}</h1>
        <p className="person-hero__titles">{personTitle}</p>
        {roles &&
          <div className="w-full">
            {roles?.map((role, i) => {
                return (
                  <span className="site-search-result__page-type mr-2" key={i}>{role}</span>
                )
              })
            }
          </div>
        }
        {
          (!!image && !!imageData) &&
          <GatsbyImage className="person-hero__image" image={imageData} alt={image.alt || `Portrait of ${name}`} />
        }
        <div className="person-hero__info-sections">
          {
            contactInfo.some(contact => !!contact.email || !!contact.office.phone || !!contact.office.address || !!contact.lab) &&
            <div className="person-hero__info-section">
              <h2 className="person-hero__info-section-title">Contact Information</h2>
              {
                contactInfo.map((info, i) => <ContactInfo key={`contact-info-${i}`} {...info} />)
              }
            </div>
          }
          {
            (!!cv || !!researchProfile?.length) &&
            <div className="person-hero__info-section">
              <h2 className="person-hero__info-section-title">Additional Info</h2>
              <AdditionalInfo cv={cv} researchProfile={researchProfile} />
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default PersonHero;